module.exports = __webpack_public_path__ + "static/media/schnips-login-logo.3ff626f5.png";